import { modals } from "@mantine/modals";
import { getMyProfile } from "../../api-clients/iwannacamp-api";
import { createLogger } from "../../utils/logger";
import DisplayNamePrompt from "./DisplayNamePrompt";

const logger = createLogger("useDisplayNamePrompt");

const DISPLAY_NAME_MODAL_ID = "display-name-prompt";

/**
 * Check if user has a display name set, and prompt them if not
 */
export const checkAndPromptDisplayName = async (idToken: string) => {
  try {
    const response = await getMyProfile({
      headers: { Authorization: `Bearer ${idToken}` },
    });

    // If user doesn't have a profile or display name, prompt them
    if (!response.data || !response.data.display_name) {
      openDisplayNamePrompt();
    }
  } catch (error) {
    logger.error("Error checking user profile:", error);
    // If there's an error, still show the prompt to be safe
    openDisplayNamePrompt();
  }
};

/**
 * Open the display name prompt modal
 */
export const openDisplayNamePrompt = (allowSkip = true) => {
  modals.open({
    modalId: DISPLAY_NAME_MODAL_ID,
    title: "Set Your Display Name",
    withCloseButton: allowSkip,
    closeOnClickOutside: allowSkip,
    closeOnEscape: allowSkip,
    centered: true,
    children: (
      <DisplayNamePrompt
        onSuccess={() => {
          modals.close(DISPLAY_NAME_MODAL_ID);
        }}
        onSkip={() => {
          modals.close(DISPLAY_NAME_MODAL_ID);
        }}
        allowSkip={allowSkip}
      />
    ),
  });
};

export { DISPLAY_NAME_MODAL_ID };
